<div id="dashboard-project" class="page-layout simple right-sidebar" fxLayout="row">
    <!-- CENTER -->
    <div class="center" fusePerfectScrollbar>

        <!-- HEADER -->
        <div class="header accent p-24 pb-0" fxLayout="column" fxLayoutAlign="space-between">
            <div fxLayout="row" fxLayoutAlign="space-between start">
                <span 
                    class="mat-display-1 my-0 my-sm-24 welcome-message" 
                    [@animate]="{value:'*',params:{x:'50px'}}">
                    Dashboard Crédito/Câmbio/Consórcio
                </span>
            </div>            
        </div>
        <!-- / HEADER -->

        <div class="content">
            <div>
                <mat-card>
                    <!-- Filtros -->
                    <mat-card-header>
                        <div 
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 ">
                            <mat-label>Regional:</mat-label>
                            <mat-form-field style="margin-left: 5px;">
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [(ngModel)]="model.regional_id"
                                    [formControl]="regional_id"
                                    (selectionChange)="selectRegional($event)">                            
                                    <mat-option 
                                        *ngFor="let regional of listRegional"
                                        [value]="regional.id">
                                        {{regional.nome}}
                                    </mat-option>                            
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerRegional"></mat-spinner>
                            </mat-form-field>            
                        </div> 

                        <div
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id == 7 || this.user.role_id == 4 || this.user.role_id == 1 || this.user.role_id == 2 || user.tipo_usuario_id == 3">
                            <mat-label>Escritório:</mat-label>
                            <mat-form-field style="margin-left: 5px;">
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [(ngModel)]="model.escritorio_id"
                                    [formControl]="escritorio_id"
                                    (selectionChange)="selectEscritorio($event)">
                                    <mat-option 
                                        *ngFor="let escritorio of listEscritorio"
                                        [value]="escritorio.id">
                                        {{escritorio.nome_fantasia}}
                                    </mat-option>                            
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerEscritorio"></mat-spinner>
                            </mat-form-field>            
                        </div>
                        
                        <div 
                            class="pl-16 pr-8 py-16 h-52" 
                            fxLayout="row"
                            fxLayoutAlign="space-between center"
                            *ngIf="this.user.role_id != 5">
                            <mat-label>Assessor:</mat-label>
                            <mat-form-field>                   
                                <mat-select 
                                    class="simplified font-size-16"
                                    aria-label="Change range"
                                    [formControl]="assessor_id"
                                    (selectionChange)="selectAssessor($event)">
                                    <mat-option value="">TODOS</mat-option>
                                    <mat-optgroup 
                                        *ngFor="let escritorio of listEscritorio" 
                                        [label]="escritorio.nome_fantasia">
                                        <mat-option 
                                        *ngFor="let usuario of escritorio.usuarios" 
                                        [value]="usuario.id">
                                        {{usuario.name}}
                                        </mat-option>
                                    </mat-optgroup>
                                </mat-select>
                                <mat-spinner diameter="20" *ngIf="loadingSpinnerAssessor"></mat-spinner>
                            </mat-form-field>
                        </div>              
                        
                    </mat-card-header>
                    <!-- / Filtros -->
                    
                    <mat-card-content>
                        <div 
                            class="widget-group p-12" 
                            fxLayout="row wrap" 
                            fxFlex="100"                             
                            [@animateStagger]="{value:'50'}"
                        > 

                            <!-- Total Clientes -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Clientes</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_clientes.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total de Clientes
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <canvas 
                                            baseChart
                                            [datasets]="total_clientes.datasets"
                                            [labels]="total_clientes.labels"
                                            [options]="total_clientes.options"
                                            >
                                        </canvas>
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de Clientes que tem registro de Crédito/Câmbio/Consórcio
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Clientes -->

                            <!-- Total Novos Clientes -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}"
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Novos Clientes</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_novos_clientes.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total de Novos Clientes
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <canvas 
                                            baseChart
                                            [datasets]="total_novos_clientes.datasets"
                                            [labels]="total_novos_clientes.labels"
                                            [options]="total_novos_clientes.options"
                                            >
                                        </canvas>
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de Novos Clientes que adquiriram consórcio no mês
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Novos Clientes -->

                            <!-- Total Clientes Prospecção -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Total de Clientes Prospects</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_clientes_prospects.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Clientes Prospects
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <canvas 
                                            baseChart
                                            [datasets]="total_clientes_prospects.datasets"
                                            [labels]="total_clientes_prospects.labels"
                                            [options]="total_clientes_prospects.options"
                                            >
                                        </canvas>
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de boletas que estão criadas que o status é igual a (Prospecção)
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Clientes Prospecção -->

                            <!-- Consorcio contratados -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Total Consórcios Contratados</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_consorcio_clientes.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Consórcios Contratados
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <canvas 
                                            baseChart
                                            [datasets]="total_consorcio_clientes.datasets"
                                            [labels]="total_consorcio_clientes.labels"
                                            [options]="total_consorcio_clientes.options"
                                            >
                                        </canvas>
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de consórcios contratados.
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Consorcio contratados -->

                            <!-- Total Consórcios Liberados -->
                            <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading>

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Total Consórcios Liberados</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            {{total_consorcios_liberados.conversion.value}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Consórcios Liberados
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!-- //todo:verificar -->
                                        <canvas 
                                            baseChart
                                            [datasets]="total_consorcios_liberados.datasets"
                                            [labels]="total_consorcios_liberados.labels"
                                            [options]="total_consorcios_liberados.options"
                                            >
                                        </canvas>
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de consórcios liberados.
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total Consórcios Liberados -->

                            <!-- Total Boletas -->
                            <!-- <ngx-shimmer-loading 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100"                     
                                fxFlex.gt-md="33"
                                *ngIf="loadingIndicator"
                            >
                            </ngx-shimmer-loading> -->

                            <fuse-widget 
                                [@animate]="{value:'*',params:{y:'100%'}}" 
                                class="widget" 
                                fxLayout="column" 
                                fxFlex="100" 
                                fxFlex.gt-xs="50" 
                                fxFlex.gt-md="33"
                                *ngIf="!loadingIndicator"
                            >

                                <!-- Front -->
                                <div class="fuse-widget-front">  
                                    <div 
                                        class="pl-16 pr-8 py-16 h-52" 
                                        fxLayout="row"
                                        fxLayoutAlign="space-between center">
                                        <div class="h3 secondary-text" fxLayout="row">Total Boletas</div>
                                        <div>
                                            <button mat-icon-button fuseWidgetToggle aria-label="more">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>                                      
                                    <div class="pt-8 pb-32" fxLayout="column" fxLayoutAlign="center center">
                                        <div 
                                            class="light-blue-fg font-size-26 line-height-26"
                                            style="cursor: pointer;">
                                            R${{total_boleta.conversion.value | number : '1.2-2'}}
                                        </div>
                                        <div class="h3 secondary-text font-weight-500">
                                            Total Boletas
                                        </div>
                                    </div>
                                    <div class="h-96 w-100-p">
                                        <!--//todo: verificar-->
                                        <canvas 
                                            baseChart
                                            [datasets]="total_boleta.datasets"
                                            [labels]="total_boleta.labels"
                                            
                                            [options]="total_boleta.options"
                                            
                                            >
                                        </canvas>
                                    </div>
                                </div>

                                <!-- Back -->
                                <div class="fuse-widget-back p-16 pt-32">
                                    <button mat-icon-button fuseWidgetToggle class="fuse-widget-flip-button"
                                            aria-label="Flip widget">
                                        <mat-icon class="s-16">close</mat-icon>
                                    </button>
                    
                                    <div class="texto-indicador">
                                        Total de boletas geradas.
                                    </div>
                                </div>
                                <!-- / Back -->
                            </fuse-widget>
                            <!-- / Total de Boletas -->
                        </div>
                    </mat-card-content>    
                </mat-card>
            </div>
        </div>
    </div>
</div>
